<template>
  <div class="mail-list-item">
    <el-tooltip content="该行明细已从该订单移除" placement="top" effect="light" v-show="showDelete">
      <span class="item-delete" >删</span>
    </el-tooltip>
    <div class="mail-list-item-text" :class="renderClass()">{{ text || '-' }}</div>
  </div>
</template>
<script>
export default {
  name: "mail-list-item",
  props: {
    text: {
      type: [String, Number, Object],
      default: ''
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: ''
    },
  },
  methods: {
    renderClass() {
      let classList = []
      if (this.textColor == 'red') {
        classList.push('red')
      }
      if (this.isDisabled) {
        classList.push('disabled')
      }
      return classList
    }
  }
}
</script>
<style lang="scss" scoped>
.mail-list-item {
  position: relative;
  padding: 12px 0 0;
  min-height: 23px;
  .item-delete {
    position: absolute;
    top: 0px;
    left: -5px;
    color: #cc0000;
  }
  .mail-list-item-text {
    font-size: 12px;
    color: #333333;
    &.red {
      color: #cc0000;
    }
    &.disabled {
      text-decoration: line-through;
    }
  }
}
</style>